import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { ModalController, LoadingController } from '@ionic/angular';
import { LoadingComponent } from 'src/app/core-files/loaders/Loader';
import { ToastComponent } from 'src/app/core-files/loaders/toast-messages';
import { SharedService } from 'src/app/core-files/shared.service.';
import { NewProjectServices } from 'src/app/services/new-project.service';
import { SharedServices } from 'src/app/services/shared.service';
import { domain } from 'src/app/variables/domain';

@Component({
  selector: 'app-upload-project-brochure',
  templateUrl: './upload-project-brochure.component.html',
  styleUrls: ['./upload-project-brochure.component.scss'],
  standalone: false
})
export class UploadProjectBrochureComponent implements OnInit {
  @ViewChild('filepickerBroucher') uploaderBroucher!: ElementRef;
  selectedBrouchur: File[] = [];
  imageUrls: any = [];
  ProjectBrochuresURL = domain.ProjectBrochures
  Id: any
  fileName: string = '';
  constructor(
    private modal: ModalController,
    private newProjectServices: NewProjectServices,
    private loadingComponent: LoadingComponent,
    private loadingController: LoadingController,
    private sharedservice: SharedService,
    private toastComponent: ToastComponent,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() { }
  addFileBrochure() {
    this.uploaderBroucher.nativeElement.click();
  }
  fileSelectedBrochure($event: any) {
    this.selectedBrouchur = Array.from($event.target.files);
    this.fileName=this.selectedBrouchur[0].name;
    let size = 0;
    if (this.selectedBrouchur.length > 0) {
      for (let i = 0; i < this.selectedBrouchur.length; i++) {
        const fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.imageUrls.push(e.target.result);
        };
        fileReader.readAsDataURL(this.selectedBrouchur[i]);
      }
      for (var count = 0; count < this.selectedBrouchur.length; count++) {
        size += this.selectedBrouchur[count].size
      }
    }
    if (this.selectedBrouchur.length > 3) {
    } else if ((size / 1024) > 5120) {
    }
  }
  async uploadBrochure() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    loading.present();
    const formData = new FormData();

    for (let i = 0; i < this.selectedBrouchur.length; i++) {
      formData.append("File", this.selectedBrouchur[i]);
    }
    // formData.append("userId", this.sharedservices.getAgentId());
    formData.append("ProjectId", this.data.item.Id);
    this.newProjectServices.UploadBrochure(formData).subscribe(
      async (res) => {
        await loading.dismiss();
        this.selectedBrouchur = null;
        this.selectedBrouchur = [];
        this.sharedservice.setImageUploaded(true);
        this.toastComponent.showToast("Brochure uploaded successfully", "success");

        this.close()
      },
      async (err) => {
        await loading.dismiss();
        this.toastComponent.showToast("Failed to upload brochure", "danger");
      }
    );
  }
  removeBrochureFile(index: number) {
    const files = Array.from(this.selectedBrouchur);
    files.splice(index, 1);
    this.selectedBrouchur = files;
  }
  close() {
    this.dialog.closeAll();
  }

  ViewBrochureFile(BrochureFileName: string) {
    // If BrochureFileName is a full URL, use it directly.
    // If it's just a filename, prepend your base URL.
    const url = BrochureFileName.startsWith('https')
      ? BrochureFileName
      : this.ProjectBrochuresURL + BrochureFileName;
    window.open(url, '_blank');
  }
  async downloadBrochureFile(item) {
    let url = this.ProjectBrochuresURL + item.BrochureFileName;
     await Browser.open({ url });
   
  }
}


